import { zilaSlab } from 'assets/theme/theme';
import { BodyText, DefaultButton, TitleMedium } from 'common/presentation/components';
import {
	Box, Card, CardActions, CardContent, CircularProgress, Stack, Typography,
} from '@mui/material';
import { backoffBackground, logo } from 'assets/images';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg';
import TextField from 'common/presentation/components/text-field/TextField';
import useAuthBackoffice from '../provider/auth-backoffice.provider';
import useNotificationsContext from 'common/presentation/providers/notifications.provider';
import { Link } from 'react-router-dom';
import AppLinks from 'assets/applinks.routes';

const ForgotPasswordPage = () => {
	const { t } = useTranslation('translations');
	const {
		forgotPassword, loading, error, setError,
	} = useAuthBackoffice();
	const { toast } = useNotificationsContext();
	const [username, setUsername] = useState<string>('');
	const [usernameError, setUsernameError] = useState<string>('');

	useEffect(() => {
		setError('');
	}, []);

	const handleForgotPassword = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!username) {
			setUsernameError(t('required'));
			return;
		}
		const result = await forgotPassword(username);
		if (result) {
			toast.current?.show({
				severity: 'success',
				summary: 'Sucesso',
				detail: result,
			});
		}
	};

	return (
		<Box sx={{
			backgroundImage: `url(${backoffBackground})`,
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			height: '100vh',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		}}
		>
			<form onSubmit={handleForgotPassword} autoComplete="off">
				<Card sx={{
					maxWidth: 410, minHeight: 450, m: 'auto', borderRadius: 4, boxShadow: 'none',
				}}
				>
					<CardContent sx={{ textAlign: 'center', m: 2 }}>
						<Box sx={{ mb: 2 }}>
							<img src={logo} alt="Logo da volt" />
						</Box>
						<TitleMedium sx={{
							fontFamily: zilaSlab, fontWeight: 500, fontSize: 20, mb: 1,
						}}
						>
							{t('forgot_password')}
						</TitleMedium>
						<BodyText sx={{
							fontSize: 14, mb: 4, paddingInline: 6, fontFamily: zilaSlab,
						}}
						>
							{t('forgot_password_info')}
						</BodyText>
						<Stack>
							<Typography color="red">
								{error}
							</Typography>
						</Stack>
						<TextField
							sx={{
								borderRadius: 2, mb: 2, height: 50, fontFamily: zilaSlab,
							}}
							placeholder={t('label_email')}
							type="email"
							value={username}
							error={!!usernameError}
							helperText={usernameError}
							onChange={(ev) => setUsername(ev.target.value)}
							startIcon={<MessageIcon />}
						/>
						<BodyText>
							<Link style={{ color: '#B9C92B' }} to={AppLinks.LOGIN_BACKOFFICE}>{t('back_to_login')}</Link>
						</BodyText>
					</CardContent>
					<CardActions sx={{ display: 'flex', justifyContent: 'center' }}>
						<DefaultButton
							disabled={loading}
							sx={{
								borderRadius: 2, width: 250, textTransform: 'capitalize', mb: 2, height: 50, fontSize: 16, fontFamily: zilaSlab,
							}}
							type="submit"
						>
							{loading && <CircularProgress size={30} />}
							{!loading && t('enter')}
						</DefaultButton>
					</CardActions>
				</Card>
			</form>
		</Box>
	);
};

export default ForgotPasswordPage;
